import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-001b8fe3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "top-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  key: 0,
  class: "showSelectInfo",
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "margin-top": "10px"
  }
};
const _hoisted_5 = {
  class: "title",
  style: {
    "flex": "0 0 100px"
  }
};
const _hoisted_6 = {
  class: "footer_select"
};
import { ref, onMounted, watch } from "vue";
import { ElForm } from "element-plus";
import { noBaseRequest } from '@/utils/request';
import { string2json } from '@/utils/form';
const __default__ = {
  name: 'dialogSelect'
};
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    url: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },
    labelStr: {
      type: String,
      default: ''
    },
    labelStr2: {
      type: String,
      default: ''
    },
    labelStr3: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '点击右侧选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: 'get'
    },
    // 表头搜索采用本地配置
    options: {
      type: Object,
      default: () => {
        return {
          localConfig: false
        };
      }
    },
    needExtraParams: {
      type: Boolean,
      default: false
    },
    // 查询额外参数
    extraParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    extraParamsProps: {
      type: Array,
      default: () => {
        return [];
      }
    },
    showSelectInfo: {
      type: Boolean,
      default: false
    },
    showSelectInfoTip: {
      type: String,
      default: '已选择内容'
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    dialogWidth: {
      type: String,
      default: '960px'
    }
  },
  emits: ['update:modelValue', 'selectLabel'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const dialogFormVisible = ref(false);
    const loading = ref(false);
    const inputStr = ref('');
    const testAreastr = ref('');
    const table = ref(null);
    const selectionRows = ref([]);
    const selectionKeys = ref([]);
    const tableData = ref({
      total: 0,
      rows: []
    });
    const searchFormPath = ref('');
    const isChangeByConfirm = ref('');
    const selectProps = ref({
      value: '',
      label: ''
    });
    const formData = ref([]);
    const formHandle = [{
      label: "搜索",
      type: "primary",
      icon: "el-icon-search",
      handle: () => handleQuery()
    }, {
      label: "重置",
      icon: "el-icon-refresh",
      class: "commonDarkBtn",
      handle: () => resetQuery()
    }];
    const tableHeader = ref([]);
    const queryParams = ref({
      pageNum: 1,
      pageSize: 5
    });
    const getList = function (query) {
      loading.value = true;
      const tempParams = JSON.parse(JSON.stringify(props.extraParams));
      // bug 12618 N-功能测试-终端运行管理-点表模板-新增，输入设备型号0，点号选择页面显示所有设备型号为0开头的点号 qz 2022/7/20
      let temp = {};
      if (props.extraParamsProps?.length) {
        for (let i = 0; i < props.extraParamsProps.length; i += 1) {
          temp[props.extraParamsProps[i]] = tempParams[props.extraParamsProps[i]];
        }
      } else {
        temp = Object.assign(temp, props.extraParams);
      }
      if (props.method === 'post') {
        noBaseRequest({
          url: searchFormPath.value,
          method: 'post',
          data: props.needExtraParams ? Object.assign(temp, queryParams.value) : queryParams.value
        }).then(res => {
          tableData.value.rows = res.data.records || [];
          tableData.value.total = res.data.total || 0;
          if (props.options.needNumberId) {
            for (let i in tableData.value.rows) {
              tableData.value.rows[i]['numberId'] = Number(i) + (queryParams.value.pageNum - 1) * queryParams.value.pageSize + 1;
            }
          }
        }).catch(err => {}).finally(() => {
          loading.value = false;
        });
      } else {
        noBaseRequest({
          url: searchFormPath.value,
          method: 'get',
          params: props.needExtraParams ? Object.assign(temp, queryParams.value) : queryParams.value
        }).then(res => {
          tableData.value.rows = res.data.records || [];
          tableData.value.total = res.data.total || 0;
          if (props.options.needNumberId) {
            for (let i in tableData.value.rows) {
              tableData.value.rows[i]['numberId'] = Number(i) + (queryParams.value.pageNum - 1) * queryParams.value.pageSize + 1;
            }
          }
        }).catch(err => {}).finally(() => {
          loading.value = false;
        });
      }
    };
    const handleQuery = function () {
      // bug 12431 N-功能测试-终端运行管理-点表模板-新增，点号选择页面，通过物模名称和点号查询不到除第一页以外的数据 qz 2022/7/1
      queryParams.value.pageNum = 1;
      getList();
    };
    const open = function () {
      dialogFormVisible.value = true;
      testAreastr.value = props.labelStr;
      setDefaultInputStr();
      resetQuery();
    };
    const cancel = function () {
      dialogFormVisible.value = false;
      //取消的话需要吧selectionKeys还原
      selectionKeys.value = props.modelValue.split(",");
    };
    const confirm = function () {
      dialogFormVisible.value = false;
      let labelList = selectionRows.value.map(item => {
        return item[selectProps.value.label];
      });
      let valueList = selectionRows.value.map(item => {
        return item[selectProps.value.value];
      });
      let valueStr = valueList.join(',');
      let labelStr = labelList.join(",");
      inputStr.value = labelStr;
      emit("selectLabel", labelStr, valueStr, selectionRows.value);
      console.log('labelStr', selectionRows);
      isChangeByConfirm.value = true;
      emit("update:modelValue", valueStr);
    };
    // watch(
    //       () => props.labelStr,
    //       (newValue) => {
    //         if (!newValue) return;
    //         let labelList = props.labelStr.split(",")
    //         props.modelValue.split(",").forEach((key,i)=>{
    //             selectionRows.value.push({[selectProps.value.value]:key,[selectProps.value.label]:labelList[i]})
    //         })
    //         inputStr.value = props.labelStr
    //       },
    //       {
    //         immediate: true,
    //       }
    //     );
    const handleSelect = function (selection, row) {
      let isChecked;
      if (selection.length == 0) {
        isChecked = false;
      } else {
        isChecked = selection.some(item => item[selectProps.value.value] == row[selectProps.value.value]);
      }
      if (isChecked) {
        selectionRows.value.push(row);
      } else {
        const rowIndex = selectionRows.value.findIndex(item => item[selectProps.value.value] == row[selectProps.value.value]);
        if (rowIndex !== -1) {
          selectionRows.value.splice(rowIndex, 1);
        }
      }

      // 解决切换页面的时候 不选中勾选的问题
      let temp = selectionRows.value.map(item => {
        return item[selectProps.value.value];
      });
      selectionKeys.value = temp;
      let labelList = selectionRows.value.map(item => {
        return item[selectProps.value.label];
      });
      let labelStr = labelList.join(',');
      testAreastr.value = labelStr;
    };
    const radioChange = function (val) {
      selectionRows.value = [val];
      //需要手动修改当前选中的key
      selectionKeys.value = [val[selectProps.value.value]];
    };
    const resetQuery = function () {
      queryParams.value = {
        pageNum: 1,
        pageSize: 5
      };
      formData.value.forEach(item => {
        if (item.multiple) {
          queryParams.value[item.prop] = [];
        } else {
          queryParams.value[item.prop] = '';
        }
      });
      getList();
    };
    watch(() => props.modelValue, newVal => {
      if (newVal && newVal.length > 0) selectionKeys.value = newVal.split(",");
      //判断是组件内部修改的还是组件外部修改的modelValue,如果是外部修改比如取消那么就需要给inputStr重新赋值
      if (!isChangeByConfirm.value) {
        inputStr.value = props.labelStr;
        testAreastr.value = props.labelStr;
      }
      // 如果外部直接设置绑定得modelvalue为空，则需要将表格选择置空
      if (!newVal) {
        selectionKeys.value = [];
        selectionRows.value = [];
      }
      isChangeByConfirm.value = false;
    }, {
      immediate: true
    });
    watch(() => props.labelStr, newVal => {
      inputStr.value = newVal;
      testAreastr.value = newVal;
    }, {
      immediate: true,
      deep: true
    });
    const setDefaultInputStr = function (row = {
      wechatGroupName: ''
    }) {
      if (props.labelStr) {
        selectionRows.value = [];
        let labelList = props.labelStr.split(",");
        let labelList2 = props.labelStr2.split(",");
        let labelList3 = props.labelStr3.split(",");
        props.modelValue.split(",").forEach((key, i) => {
          selectionRows.value.push({
            [selectProps.value.value]: key,
            [selectProps.value.label]: labelList[i],
            deptName: labelList2[i],
            courtsManageName: labelList3[i]
          });
        });
        // setTimeout(()=>{
        //     console.log(props.labelStr,'_____labelStr');
        //     inputStr.value = props.labelStr
        // },100)
      }
    };
    watch(() => props.url, newVal => {
      if (newVal) {
        if (props.options.localConfig) {
          tableHeader.value = props.options.tableHeader || [];
          formData.value = props.options.searchFormData || [];
          selectProps.value.label = props.options.backFillData.label;
          selectProps.value.value = props.options.backFillData.prop;
          searchFormPath.value = props.options.routePath;
          tableData.value = {
            rows: props.options.routePath.length == 0 ? props.options.listDatas.rows : []
          };
          props.options.searchFormData.forEach(item => {
            if (item.multiple) {
              queryParams.value[item.prop] = [];
            } else {
              queryParams.value[item.prop] = '';
            }
          });
          setDefaultInputStr();
          return;
        }
        noBaseRequest({
          url: newVal,
          method: 'get'
        }).then(res => {
          const {
            searchFormData,
            tableHeader: tableHeaderData,
            listDatas,
            backFillData,
            routePath
          } = res.data;
          tableHeader.value = tableHeaderData || [];
          formData.value = searchFormData || [];
          selectProps.value.label = backFillData.label;
          selectProps.value.value = backFillData.prop;
          searchFormPath.value = routePath;
          tableData.value = listDatas || {
            rows: []
          };
          searchFormData.forEach(item => {
            if (item.multiple) {
              queryParams.value[item.prop] = [];
            } else {
              queryParams.value[item.prop] = '';
            }
          });
          setDefaultInputStr();
        }).catch(err => {});
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        disabled: "",
        modelValue: inputStr.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => inputStr.value = $event),
        formatter: value => `${value}`.replace(/(^\s*)|(\s*$)/g, ''),
        placeholder: __props.placeholder,
        class: "input-with-select"
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          class: "btn",
          disabled: __props.disabled,
          onClick: open
        }, {
          default: _withCtx(() => [_createTextVNode("选择")]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      }, 8, ["modelValue", "formatter", "placeholder"]), _createVNode(_component_el_dialog, {
        "close-on-click-modal": false,
        "append-to-body": true,
        modelValue: dialogFormVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogFormVisible.value = $event),
        title: "选择数据",
        "custom-class": "no-inhert-dialog",
        style: _normalizeStyle({
          width: __props.dialogWidth
        })
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
          form: queryParams.value,
          formData: formData.value,
          formHandle: formHandle,
          showLabel: __props.showLabel,
          style: {
            "margin-bottom": "20px"
          }
        }, null, 8, ["form", "formData", "showLabel"])])]), _withDirectives(_createVNode(_component_commonTable, {
          class: _normalizeClass(__props.multiple ? '' : 'common_table'),
          hasSelect: __props.multiple,
          radioSelect: !__props.multiple,
          columnSetting: false,
          tableData: tableData.value,
          tableHeader: tableHeader.value,
          queryParams: queryParams.value,
          selectAllNeedSelect: true,
          ref_key: "table",
          ref: table,
          "row-key": selectProps.value.value,
          selectionKeys: selectionKeys.value,
          onGetList: getList,
          onRadioChange: radioChange,
          onSelect: handleSelect
        }, null, 8, ["class", "hasSelect", "radioSelect", "tableData", "tableHeader", "queryParams", "row-key", "selectionKeys"]), [[_directive_loading, loading.value]]), __props.showSelectInfo ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(__props.showSelectInfoTip), 1), _createVNode(_component_el_input, {
          modelValue: testAreastr.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => testAreastr.value = $event),
          type: "textarea",
          disabled: true,
          style: {
            "flex": "1"
          }
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue", "style"])]);
    };
  }
});